import { InitDataFormModel } from './initDataForm';


export class InitFormModel {
    country = 'EC';
    application = 'DATAMALL';
    requestType = 'FORM';
    emissionDate: string;
    data: InitDataFormModel;
      constructor(personType = 'N') {
        this.data = new InitDataFormModel(personType);
        this.emissionDate = new Date().toISOString();
    }
}
